import { registerPlugin } from '@capacitor/core';

export type PeakHealthWorkout = {
  uuid: string;
  startDate: string;
  endDate: string;
  duration: number;
  totalEnergyBurned?: number;
  totalDistance?: number;
  workoutActivityId?: number;
  workoutActivityName?: string;
};

export interface PeakHealthPlugin {
  isAvailable(): Promise<{ available: boolean }>;
  requestAuthorization(): Promise<{ ok: boolean }>;
  queryTodaySummary(): Promise<{ steps: number; activeCalories: number }>;
  queryLatestWeight(): Promise<{ weightKg: number | null }>;
  queryRecentWorkouts(options: { days: number }): Promise<{ workouts: PeakHealthWorkout[] }>;
}

export const PeakHealth = registerPlugin<PeakHealthPlugin>('PeakHealth');
